module.exports = __webpack_public_path__ + "img/icon10.52fbdb45.svg";